/**            
 * 调试帮助类            
 */
var debugHelper = {
	/**            
	 * 用来控制(console.log)是否输出调试信息, 并决定一些界面元素是否显示            
	 */
	switch: false,
	/**            
	 * 受switch管理的log方法            
	 * @param {*} msg 需要在控制台显示的内容            
	 */
	log: function (msg) {
		if (this.switch) {
			console.log(msg)
		}
	},
	/**            
	 * 判断是不是Debug模式            
	 */
	isDebugMode: function () {
		return this.switch
	},
}
export default debugHelper            
